import React, { useRef, useEffect, useState } from 'react';
import styles from './BorderTrail.module.css';

export const BorderTrail = ({
  children,
  color = "rgba(239, 68, 68, 0.8)", // Default red-ish
  trailSize = 100, // Length of the trail in pixels
  speed = 100, // Pixels per second
  strokeWidth = 2,
  className = ""
}) => {
  const containerRef = useRef(null);
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  useEffect(() => {
    if (!containerRef.current) return;

    const updateDimensions = () => {
      const { offsetWidth, offsetHeight } = containerRef.current;
      setDimensions({ width: offsetWidth, height: offsetHeight });
    };

    updateDimensions();
    const resizeObserver = new ResizeObserver(updateDimensions);
    resizeObserver.observe(containerRef.current);

    return () => resizeObserver.disconnect();
  }, []);

  const perimeter = 2 * (dimensions.width + dimensions.height);
  const duration = perimeter / speed; // time = distance / speed

  // Create a dasharray that has one "trail" and then a gap for the rest of the perimeter
  const gapSize = Math.max(0, perimeter - trailSize);
  const strokeDasharray = `${trailSize} ${gapSize}`;

  return (
    <div className={`${styles.container} ${className}`} ref={containerRef}>
      {children}
      {dimensions.width > 0 && (
        <svg
          className={styles.svgOverlay}
          width={dimensions.width}
          height={dimensions.height}
          viewBox={`0 0 ${dimensions.width} ${dimensions.height}`}
          style={{
            '--duration': `${duration || 0}s`,
            '--perimeter': `${perimeter || 0}px`
          }}
        >
          <rect
            x={strokeWidth / 2}
            y={strokeWidth / 2}
            width={Math.max(0, dimensions.width - strokeWidth)}
            height={Math.max(0, dimensions.height - strokeWidth)}
            // Use 16px as default radius matching .field-input
            rx={16}
            fill="none"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeDasharray={strokeDasharray}
            strokeLinecap="round"
            className={styles.trail}
          />
        </svg>
      )}
    </div>
  );
};
